import { FC } from 'react'
import { IButton } from 'types/ui/button.interface'
import { StyledButton } from './Button.styled'

export const Button: FC<IButton> = ({
  variant = 'primary',
  size = 'md',
  iconLeft,
  children,
  type = 'button',
  ...rest
}) => {
  return (
    <StyledButton $variant={variant} $size={size} type={type} {...rest}>
      {iconLeft}
      {children}
    </StyledButton>
  )
}
